import {AsideMenuItem} from '../../_metronic/layout/components/aside/AsideMenuItem'
import {useAuth} from '../modules/auth'

export function AsideSystemMenu() {
  const {isAdmin, userVerifyRoles} = useAuth()
  const isCompanyModerator = userVerifyRoles(['Company Moderator'])

  return (
    <>
      {isAdmin && (
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>System</span>
        </div>
      </div>
      )}
      {isAdmin && (
        <AsideMenuItem
          to='/user-management/users'
          icon='/media/icons/duotune/general/gen051.svg'
          title='User Management'
          fontIcon='bi-layers'
        />
      )}
      {isCompanyModerator && (
        <AsideMenuItem
          to='/company-management/companies'
          icon='/media/icons/duotune/general/gen051.svg'
          title='Company Management'
          fontIcon='bi-layers'
        />
      )}
      {isAdmin && (
        <AsideMenuItem
          to='/logs-management/logs'
          icon='/media/icons/duotune/general/gen051.svg'
          title='Logs'
          fontIcon='bi-layers'
        />
      )}
    </>
  )
}
